import { render, staticRenderFns } from "./UiIcon.vue?vue&type=template&id=d9f218a2&"
import script from "./UiIcon.vue?vue&type=script&lang=js&"
export * from "./UiIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports